<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <refresh-item
      :show="showDigioScriptRefresh"
      @onRefresh="loadDigioScript"
    ></refresh-item>

    <refresh-item
      :show="showEsignConfigRefresh"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <stage-comment-item></stage-comment-item>

    <div v-if="lenderPlatformMessage"
         class="margin_top_20 margin-left-10 margin-right-10">
      <weex-text
        class="font-size-sm-base text-color-black"
        v-html="lenderPlatformMessage"
      ></weex-text>
      <table class="w100">
        <tr>
          <td>
             <wxc-button
              text="Refresh"
              class="button_horizontal_center margin_top_40"
              size="big"
              type="blue"
              @wxcButtonClicked="checkAndRedirectToNextTask">
            </wxc-button>
          </td>
          <td>
            <wxc-button
              text="Back"
              class="button_horizontal_center margin_top_40"
              size="big"
              type="blue"
              @wxcButtonClicked="redirectToLoanActivity">
            </wxc-button>
          </td>
        </tr>
      </table>
    </div>


    <div v-else-if="showUI && !showDigioScriptRefresh && !showEsignConfigRefresh"
         class="margin_top_20">
      <div class="input_container bottom-line">
        <weex-text class="input_label">Sign documents</weex-text>
      </div>

      <div v-if="esignAllowed">
        <div class="input_container">
          <weex-text class="input_label">Choose sign mode option</weex-text>
          <wxc-radio
            :list="signModeOptions"
            :config="radioButtonConfig"
            :radio-button-on-right="false"
            :has-bottom-border="false"
            @wxcRadioListChecked="signModeOptionSelected">
          </wxc-radio>
        </div>

        <wxc-button
          text="Continue"
          class="button_horizontal_center margin_top_40"
          size="big"
          type="blue"
          @wxcButtonClicked="onContinueEsignClicked">
        </wxc-button>
      </div>

      <div class="margin_top_20" v-if="manualSignAllowed">
        <weex-text class="text-align-center font-weight-bold text-color-gray">-OR-</weex-text>
        <weex-text
          class="item-base-link text-align-center"
          @click="saveSignMode('MANUAL')">
          Continue with manual sign
        </weex-text>
      </div>
    </div>
  </div>
</template>
<script>
import ToolBar from "../../layout/ToolBar";
import Loading from "../../layout/Loading";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import StageCommentItem from "../../layout/StageCommentItem";
import WxcRadio from "../../../../weex-ui/packages/wxc-radio/index";
import WxcButton from "../../../../weex-ui/packages/wxc-button/index";
import LoanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import DataSource from "../../../data/DataSource";
import LoanTasksActivityNavigator from "../../../utils/LoanTasksActivityNavigator";
import EzUtils from "../../../utils/EzUtils";
import ActivityNavigator, { Activities } from "../../../utils/ActivityNavigator";
import { DefaultResourceConfig } from "../../../utils/ImageResourcesUtil";
import { MessageConstants } from "../../../utils/MessageConstantUtil";
import AlertService from "../../core/alert/AlertService";
import { environment } from "../../../environments/environment";
import RefreshItem from "../../layout/RefreshItem";
import ErrorAlertItem from "../../layout/ErrorAlertItem";
import LoanTasksUtility from "../../../utils/LoanTasksUtility";
import storageUtil from "../../../utils/StorageUtil";
import loanTaskUtility from "@/utils/LoanTasksUtility";
import loanScopeDataHolder from "@/data/model/LoanScopeDataHolder";

export default {
  name: "DigioEsignActivity",
  components: {
    ErrorAlertItem,
    Loading,
    ToolBar,
    WxcButton,
    WxcRadio,
    ActivityRedirectItem,
    StageCommentItem,
    RefreshItem
  },
  data: () => ({
    options: null,
    signModeOptions: [],
    selectedSignModeOption: "",
    manualSignAllowed: false,
    esignAllowed: false,
    esignConfiguration: null,
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showUI: false,
    showDigioScriptRefresh: false,
    showEsignConfigRefresh: false,
    lenderPlatformMessage: "",
    enableAutoRefresh: false,
    autoRefreshInterval: null,
  }),

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    showToast(message) {
      AlertService.showToast(message);
    },

    signModeOptionSelected(e) {
      this.selectedSignModeOption = e.value;
    },

    continueEsign(signMode) {
      if (!this.esignConfiguration
        || !this.esignConfiguration.requestId
        || !this.esignConfiguration.mobile
      ) {
        this.showError({ title: "Document id or phone number cannot be empty." });
        return;
      }

      this.loadDigioScript();
    },

    loadDigioScript() {
      const outerContext = this;
      this.showDigioScriptRefresh = false;
      this.loading = true;
      const recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute("src", environment.digioScriptUrl);
      recaptchaScript.setAttribute("type", "text/javascript");
      document.head.appendChild(recaptchaScript);

      recaptchaScript.onload = function () {
        outerContext.loading = false;
        outerContext.continueEsignOnDigio();
      };
      recaptchaScript.onerror = function () {
        outerContext.loading = false;
        outerContext.showDigioScriptRefresh = true;
      };
    },

    continueEsignOnDigio() {
      const self = this;
      this.options = {
        environment: environment.digioEnvironment,
        callback: function (response) {
          if (response.hasOwnProperty("error_code")) {
            self.onSigningFailure();
          } else {
            self.onSigningSuccess()
          }
        },
        logo: "",
        theme: {
          primaryColor: "#AB3498",
          secondaryColor: "#000000"
        },
        is_iframe: true
      };
      // eslint-disable-next-line no-undef
      const digio = new Digio(this.options);
      digio.init();
      digio.submit(this.esignConfiguration.requestId, this.esignConfiguration.mobile);
    },

    onSigningSuccess() {
      this.triggerDocService();
    },

    onSigningFailure() {
      this.showToast(MessageConstants.DOCUMENT_SIGNING_FAILED_MESSAGE);
      ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
    },

    continueManualSign() {
      this.showToast(MessageConstants.MANUAL_SIGN_OPTION_NOT_SUPPORTED);
    },

    continueWebSign() {
      LoanScopeDataHolder.setWebViewSecretKey(this.esignConfiguration.secretKey);
      ActivityNavigator.navigateTo(Activities.LENDER_TERMS_AND_CONDITIONS);
    },

    onContinueEsignClicked() {
      if (EzUtils.isNotEmpty(this.selectedSignModeOption)) {
        this.saveSignMode(this.selectedSignModeOption);
      } else {
        this.showToast(MessageConstants.CHOOSE_SIGN_MODE_OPTION);
      }
    },

    saveSignMode(signMode) {
      const signModeRequest = {
        loanId: LoanScopeDataHolder.getLoanId(),
        loanStage: LoanScopeDataHolder.getCurrentLoanTask().name,
        esignMode: signMode
      };
      this.loading = true;
      DataSource.saveSignMode(signModeRequest)
        .then(signModeSaveRes => {
          this.loading = false;
          if (signModeSaveRes.errorOccurred) {
            this.showError(signModeSaveRes.data);
          } else {
            switch (signMode) {
              case 'FINGER_PRINT':
              case 'OTP':
                this.continueEsign(signMode);
                break;

              case 'MANUAL':
                this.continueManualSign();
                break;

              case 'WEBVIEW':
                this.continueWebSign();
                break;

            }
          }
        })
    },

    needToShowSignModeOptions(esignConfiguration) {
      let noOfSignModeOptions = 0;
      if (esignConfiguration.esignMethod === "WEBVIEW") {
        noOfSignModeOptions++;
      }

      if (esignConfiguration.esignAllowed) {
        noOfSignModeOptions += 2;
      }

      if (esignConfiguration.manualSignAllowed) {
        noOfSignModeOptions++;
      }
      return noOfSignModeOptions > 1;
    },

    getSingleSignMode(esignConfiguration) {
      if (esignConfiguration.esignMethod === "WEBVIEW") {
        return "WEBVIEW";
      }

      if (esignConfiguration.manualSignAllowed) {
        return "MANUAL";
      }
      return null;
    },

    showSignModeOptions(esignConfiguration) {
      if (esignConfiguration.esignAllowed) {
        this.signModeOptions.push({ title: "OTP", value: "OTP" });
        //TODO FINGER_PRINT option is not added. need to add only for agent.
        this.esignAllowed = true;
      }

      if (esignConfiguration.esignMethod === "WEBVIEW") {
        this.signModeOptions.push({ title: "Lender's Page", value: "WEBVIEW" });
        this.esignAllowed = true;
      }

      if (esignConfiguration.manualSignAllowed) {
        this.manualSignAllowed = true;
      }
    },

    triggerDocService() {
      let document = null;
      if ("SIGN_LENDER_DOCUMENT" === this.currentTaskName) {
        document = "SIGNED_DOCUMENT";
      } else if ("EZCRED_SIGN_LENDER_DOCUMENT" === this.currentTaskName) {
        document = "EZCRED_SIGNED_DOCUMENT";
      }

      DataSource.triggerDocument(
        LoanScopeDataHolder.getLoanId(),
        LoanScopeDataHolder.getClientId(),
        document
      );
      this.getNextTask();
    },

    getNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
            this.setIntervalForAutoRefreshIfRequired();
          }
        });
    },

    fetchInitialData() {
      this.showEsignConfigRefresh = false;
      this.loading = true;
      LoanTasksUtility.getLoanStageConfigData(LoanScopeDataHolder.getLoanId(), this.currentTaskName)
        .then(stageConfigRes => {
          this.loading = false;
          if (stageConfigRes.errorOccurred) {
            this.showError(stageConfigRes.data);
            this.showEsignConfigRefresh = true;
          } else {
            const stageProperties = stageConfigRes.data && stageConfigRes.data.properties
              ? stageConfigRes.data.properties
              : {};
            if (stageProperties.completeOnLenderPlatform) {
              const lenderPlatformDetails = stageProperties.lenderPlatformDetails;
              if (lenderPlatformDetails && lenderPlatformDetails.message) {
                this.lenderPlatformMessage = lenderPlatformDetails.message;
                this.enableAutoRefresh = true;
                this.setIntervalForAutoRefreshIfRequired();
              }
            } else {
              this.getEsignConfiguration();
            }
          }
        })
    },

    getEsignConfiguration() {
      let taskEnum = LoanScopeDataHolder.getCurrentLoanTask().name;
      if (taskEnum == null) {
        taskEnum = LoanScopeDataHolder.getCurrentLoanTask().otherTaskEnum;
      }
      this.loading = true;
      DataSource.getEsignConfiguration(
        { loanId: LoanScopeDataHolder.getLoanId(), loanStage: taskEnum }
      )
        .then(esignConfigRes => {
          this.loading = false;
          if (esignConfigRes.errorOccurred) {
            this.showError(esignConfigRes.data);
            this.showEsignConfigRefresh = true;
          } else {
            LoanScopeDataHolder.setEsignConfiguration(esignConfigRes.data);
            this.esignConfiguration = esignConfigRes.data;

            if (this.needToShowSignModeOptions(this.esignConfiguration)) {
              this.showSignModeOptions(this.esignConfiguration);
              this.showUI = true;
            } else {
              const signMode = this.getSingleSignMode(this.esignConfiguration);
              if (EzUtils.isNotEmpty(signMode)) {
                this.saveSignMode(signMode);
              } else {
                this.showToast(MessageConstants.NO_SIGN_MODE_PRESENT);
                //TODO show single message dialog
              }
            }
          }
        })
    },

    redirectToLoanActivity() {
      this.clearIntervalForAutoRefreshIfRequired();
      ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
    },

    checkAndRedirectToNextTask() {
      this.clearIntervalForAutoRefreshIfRequired();
      this.loading = true;
      loanTaskUtility.getTasks(loanScopeDataHolder.getLoanId(), false, null)
      .then(res => {
        this.loading = false;
        if (res.errorOccurred) {
          this.showError(res);
          this.setIntervalForAutoRefreshIfRequired();
        } else {
          let signLenderDetailsTask = this.getSignLenderLoanTask(res.data.agentTasks);
          if(signLenderDetailsTask && signLenderDetailsTask.task_status === "COMPLETED"){
            this.getNextTask();
          }else{
            this.setIntervalForAutoRefreshIfRequired();
          }
        }
      });
    },

    getSignLenderLoanTask(loanTaskList) {
      let signLenderDetailsTask = null;
      if(loanTaskList){
        loanTaskList.forEach(it => {
          if (Activities.SIGN_LENDER_DOCUMENT === it.name) {
            signLenderDetailsTask = it
          }
        });
      }
      return signLenderDetailsTask
    },

    setIntervalForAutoRefreshIfRequired(){
      if(this.enableAutoRefresh){
        this.autoRefreshInterval = setInterval(this.checkAndRedirectToNextTask,10000);
      }
    },

    clearIntervalForAutoRefreshIfRequired(){
      if(this.autoRefreshInterval){
        clearInterval(this.autoRefreshInterval);
      }
    },
  },

  mounted() {
    this.fetchInitialData();
  },

  computed: {
    radioButtonConfig() {
      return DefaultResourceConfig.RADIO_BUTTON;
    },

    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.SIGN_LENDER_DOCUMENT];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    toolbarTitle() {
      return LoanScopeDataHolder.isOnboardingLoan()
          ? "Merchant Agreement Signature" : "Loan Agreement Signature";
    },
  }
}

</script>

<style scoped src="../../../assets/style/base.css"></style>

